import { observable } from "mobx";
import Model from "~/models/Model";

class Tax extends Model {
  /**
   * @property {number|null}
   */
  @observable taxId = null;

  /**
   * @property {string}
   */
  @observable name = "";

  /**
   * @property {string}
   */
  @observable state = "";

  /**
   * @property {string}
   */
  @observable country = "";

  /**
   * @property {number}
   */
  @observable rate = 0;
}

export default Tax;
